<template>
 <div :class="$style['goods-form']">
     <!-- 1、子模块样式。所有子模块的label右对齐
     a、每个子模块中，随意挑选一个pt-form-list-item（因为同一个子模块，label的宽度是相等的）,调用widthItem方法，在此方法中，
     将每一次获取的宽度push进一个数组。取出数组中的最大值，在每个子模块中，随意挑选一个pt-form-list-item，将最大值（widthMax）传入-->
    <pt-sub-title title="商品类型"></pt-sub-title>
    <table>
        <tr></tr>
        <pt-form-list-item label="商品归属：" :required="true"  @widthItem="widthItem" :widthMax="width_max">
            <wt-radio :radios="goodsBelongLabels" v-model="goodsData.goodsBelong"  data-vv-as="商品归属"
            name="type"  v-validate="'required'" @change="goodsBelongChange"></wt-radio>
        </pt-form-list-item>
        <pt-form-list-item label="商品类型：" :required="true" >
            <wt-selector :options="goodsTypes" v-model="goodsData.type" :props="goodsTypeProps" data-vv-as="商品类型"
            name="type"  v-validate="'required'" :loading="goodsTypeLoading"></wt-selector>
        </pt-form-list-item>
        <pt-form-list-item  label="公司归属：" :required="true">
          <wt-selector :options="companyList" :props="{label:'fullName',value:'id'}" filterable v-model="goodsData.goodsCompanies"  data-vv-as="公司归属"
        name="type"  v-validate="'required'" multiple></wt-selector>
        </pt-form-list-item>
        <pt-form-list-item label="事业部归属：" :required="true">
          <wt-selector :options="businessDepartments" :props="{label:'name',value:'id'}" v-model="goodsData.businessDepartmentId" data-vv-as="事业部归属"
          name="type"  v-validate="'required'"></wt-selector>
        </pt-form-list-item>
        <pt-form-list-item label="产品编码：" >
          <wt-input v-model="goodsData.productCode" :class="$style['product-code']"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="咨询类商品：" :required="true" >
            <div>
            <el-switch v-model="goodsData.justShow"></el-switch><span :class="$style['goods-form-tiptext']">如果商品不提供在线购买，请将该开关开启。用户可浏览商品信息，联系咨询师咨询详情。</span>
            </div>
        </pt-form-list-item>
        <pt-form-list-item label="是否在商城展示：">
            <div>
           <el-switch v-model="goodsData.mallVisible"></el-switch><span :class="$style['goods-form-tiptext']">开关关闭后，该商品将不在商城展示，但保持所有已设置的商品信息。</span>
           </div>
        </pt-form-list-item>
           <pt-form-list-item label="是否在分享中展示：">
            <div>
           <el-switch v-model="goodsData.shareVisible"></el-switch><span :class="$style['goods-form-tiptext']">开关关闭后，该商品将不在分享列表中展示，但保持所有已设置的商品信息。</span>
           </div>
        </pt-form-list-item>
        <pt-form-list-item label="是否允许用户下单：">
            <div>
           <el-switch v-model="goodsData.allowCustomerOrder"></el-switch><span :class="$style['goods-form-tiptext']">开关关闭后，该商品将不能被用户购买。</span>
           </div>
        </pt-form-list-item>
         <pt-form-list-item label="是否在首页展示：">
            <div>
           <el-switch v-model="goodsOtherInfoDTO.recommend"></el-switch>
           </div>
        </pt-form-list-item>
            <template v-if="isThirdParty">
                <pt-form-list-item label="是否外部链接：">
                    <div>
                        <el-switch v-model="goodsData.isExternalUrl"></el-switch><span :class="$style['goods-form-tiptext']">例如商品为保险等第三方商品，需要在此输入外部链接</span>
                    </div>
                </pt-form-list-item>
                <pt-form-list-item label="链接：" v-if="goodsData.isExternalUrl">
                    <wt-input v-model="goodsData.externalUrl"></wt-input>
                </pt-form-list-item>
            </template>
        <template v-if="!justShow">
            <pt-form-list-item label="收款账户：" :required="true" v-if="!goodsData.isExternalUrl">
                <div>
                <wt-selector :options="collectionsLabel" v-model="vendorInfo.paymentAccount" data-vv-as="收款账户"
            name="type"  v-validate="'required'"></wt-selector>
            <span :class="$style['goods-form-tiptext']">请选择C端用户向中源协和付款还是供应商付款</span>
            </div>
            </pt-form-list-item>
            <pt-form-list-item  :label="paymentLabel" :required="true" v-if="isSelectVendorsOrganizations">
                <wt-selector :options="organizationOptions" :props="{label:vendorInfo.paymentAccount==='MOLECULAR_COMPANY'?'fullName':'name',value:'id'}" filterable v-model="vendorInfo.organizationId"  data-vv-as="供应商"
            name="type"  v-validate="'required'"></wt-selector>
            </pt-form-list-item>
        </template>
        <pt-form-list-item label="是否需填写表单：" :required="formIsRequired">
          <el-switch v-model="goodsData.hasForm" @change="hasFormChange"></el-switch>
        </pt-form-list-item>
        <pt-form-list-item label="表单id：" :required="formIsRequired">
          <wt-input v-model="goodsData.formId" :class="$style['product-code']" placeholder="请去到报名列表“复制表单ID”" data-vv-as="表单id"
            name="formId"  v-validate="formIsRequired?'required':false"></wt-input>
        </pt-form-list-item>
    </table>
    <pt-sub-title title="商品信息" ></pt-sub-title>
    <table :class="$style['message-table']">
        <template v-if="isShowPackage">
          <gene-package-of-goods :goodsData="goodsData" @selectMeal="selectMeal"   @widthItem="widthItem"></gene-package-of-goods>
        </template>
        <pt-form-list-item label="商品名称：" :required="true"   @widthItem="widthItem"  :widthMax="width_max">
            <wt-input placeholder="请输入商品名称" :class="$style['goods-name']" v-model="goodsData.name" data-vv-as="商品名称" name="name"  v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="商品描述：" :required="true">
            <wt-input placeholder="请输入商品描述（最多输入10个字）" type="textarea" rows='4' :autosize="{ minRows: 4, maxRows: 5}" :max-length="10"
            :class="$style['input-style']"   v-model="goodsData.description" data-vv-as="商品描述" name="name"  v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="商品分组：" :required="true">
            <div>
                <wt-selector :options="goodsGroup" v-model="goodsData.groupId"  :props="groupProps" data-vv-as="商品分组" name="name"  v-validate="'required'"></wt-selector>
                <el-button style="margin-left:10px" type="text" @click="setGroup">分组设置</el-button>
            </div>
        </pt-form-list-item>
        <pt-form-list-item label="商品周期：" v-if="isGENE&&!justShow" :required="true">
            <div :class="$style['goods-cycle']">
            <wt-input-number v-model="goodsData.cycle" :min="1"  data-vv-as="商品周期" name="name"  v-validate="'required'"></wt-input-number>
            <wt-radio :radios="cycleRadios" :class="$style['cycle-radio']" v-model="goodsData.cycleType"  data-vv-as="商品周期类型" name="name"  v-validate="'required'"></wt-radio>
            </div>
        </pt-form-list-item>
                <pt-form-list-item label="商品主图：" :required="true">
            <template>
            <wt-upload-file class="main-pictrue-upload" :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl"
            v-model="goodsData.mainPicture" data-vv-as="商品主图" name="name"  v-validate="'required'" :multiple="false">
                <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
            </wt-upload-file>
            <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：694*694像素；建议分辨率：120dpi；图片格式：.jpg、.png</div>
            </template>
        </pt-form-list-item>
        <pt-form-list-item label="商品图：" :required="true" v-if="!goodsData.isExternalUrl">
            <template>
            <wt-upload-file  class="goods-pictrue-upload" :class="$style['goods-pictrue-upload']" :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl"
            v-model="goodsData.pictures" data-vv-as="商品图" name="name"  v-validate="'required'">
                <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
            </wt-upload-file>
            <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：694*490像素；建议分辨率：120dpi；图片格式：.jpg、.png</div>
            </template>
        </pt-form-list-item>
        <pt-form-list-item label="广告位图片：" :required="true">
            <template>
            <wt-upload-file :action="uploadApi" class="goods-banner-pictrue-upload"  :class="$style['goods-banner-pictrue-upload']" :data="picture_params" :img-url="privateResourcesUrl"
            v-model="goodsData.bannerPicture" :multiple="false" data-vv-as="广告位图片" name="name"  v-validate="'required'">
                <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
            </wt-upload-file>
            <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：694x256像素；建议分辨率：120dpi；图片格式：.jpg、.png</div>
            </template>
        </pt-form-list-item>
        <template v-if="!justShow&&!goodsData.isExternalUrl">
            <pt-form-list-item label="标签：">
                <el-button  type="primary" plain @click="selectLabs">点击选择标签</el-button>
                <!-- <wt-selector :options="goodsTags" v-model="form.labelIds"></wt-selector> -->
            </pt-form-list-item>
            <pt-form-list-item label="已选标签：" v-if="goodsData.tags&&goodsData.tags.length>0">
                <div class="page-background">
                    <table :class="$style['specification-table']">
                        <tr>
                            <td>标签名称</td>
                            <td>标签类型</td>
                            <td>权重</td>
                        </tr>
                        <tr v-for="(item,index) in goodsData.tags" :key="index">
                            <td>{{item.name}}</td>
                            <td>{{item.type}}</td>
                            <td><wt-input-number placeholder="1-10" v-model="item.weight" :min="1" @blur="weightChange(item)" ></wt-input-number></td>
                        </tr>
                    </table>
                </div>
            </pt-form-list-item>
         </template>
         <template v-if="!goodsData.isExternalUrl">
         <pt-form-list-item label="商品规格：" :required="goodsData.justShow?true:false" >
             <el-button type="primary" plain v-if="!specifications||specifications.length===0" @click="addSpecifications">点击添加规格</el-button>
             <specification-table v-else v-model="specifications" :justShow="justShow" :type="goodsData.type"></specification-table>
             <!-- <wt-input v-if="goodsData.justShow" v-model="specifications[0].items[0].name" data-vv-as="商品规格" name="name"  v-validate="'required'" style="display:none"></wt-input> -->
         </pt-form-list-item>
         <pt-form-list-item label="规格明细：" v-if="!justShow&&specifications&&specifications.length!==0&&specifications[0]&&specifications[0].items&&specifications[0].items.length>0">
             <div :class="$style['specification-table-div']" class="page-background">
                <table :class="$style['specification-table']">
                    <th>
                        <td>
                            <!-- 报告形式 -->
                            </td>
                        <td><span style="color:red">*</span>价格（元）</td>
                        <td v-if="showStockQuantity"><span  style="color:red">*</span>库存</td>
                        <!-- <td>操作</td> -->
                        <td v-if="isShowPromotionPrice">折后价</td>
                        <td>邀请人奖励</td>
                        <td>业务员奖励</td>
                        <td>奖励积分（积分）</td>
                    </th>
                    <tr v-for="(etem,index) in specifications[0].items" :key="index">
                        <td>{{etem.name}}</td>
                        <td><div :class="$style['specifications-tr-input-div']">
                            <wt-input v-model="etem.show_price" @change="showPriceInput" @focus="showPriceFocus(index)" data-vv-as="规格价格" name="name"  :class="$style['specifications-tr-input']" v-validate="'required|decimal:2|min_value:0|is_not:0'"></wt-input>
                        </div></td>
                        <td v-if="showStockQuantity"><div :class="$style['specifications-tr-input-div']">
                            <wt-input v-model="etem.stockQuantity" data-vv-as="规格库存" name="name" :class="$style['specifications-tr-input']"  v-validate="'required'"></wt-input>
                            </div></td>
                            <td v-if="isShowPromotionPrice">{{etem.promotionPrice}}</td>
                            <td>
                              <div  :class="$style['reward-money-just-salesman']">
                              <wt-input v-model="etem.inviterRewardMoney" @change="inviterRewardMoneyInput(etem)"></wt-input>
                              <el-checkbox v-model="etem.justSalesman" @change="justSalesmanChange(etem)">仅限业务员奖励</el-checkbox>
                              </div>
                            </td>
                            <td>
                               <wt-input v-model="etem.salerRewardMoney" @change="salerRewardMoneyInput(etem)"></wt-input>
                            </td>
                          <td>
                            <wt-input v-model="etem.rewardPoint" @change="rewardPointInput(etem)" type="number"
                            v-validate="'min_value:0'"></wt-input>
                          </td>
                    </tr>
                </table>
             </div>
         </pt-form-list-item>
         </template>
         <!-- <template  v-if="!justShow&&!goodsData.isExternalUrl"> -->
         <pt-form-list-item label="价格：" :required="true" v-if="!justShow">
             <wt-input :disabled="specificationsItem.show_price?true:false" @change="changeFinalPrice"  data-vv-as="商品价格" name="name" v-validate="'required|moreequalzero|decimal:2|min_value:0'" :class="$style['number-input-price']" v-model="goodsData.final_price" :min="0"><el-button slot="append">¥</el-button></wt-input>
         </pt-form-list-item>
          <!-- <pt-form-list-item label="折后最低价：" :required="true" v-if="!justShow">
            {{goodsData.}}
         </pt-form-list-item> -->
         <pt-form-list-item label="是否提供发票：" required>
             <wt-radio :radios="provideInvoiceList" v-model="goodsData.provide_invoice" data-vv-as="是否提供发票" name="name"  v-validate="'required'"></wt-radio>
         </pt-form-list-item>
         <tax-project-comp  v-if="isHasTax" :tax-requry="tax_requry" @selectTax="selectTax" :tax-project="tax_project" :isHasTaxTable="isHasTaxTable"></tax-project-comp>
         <pt-form-list-item label="库存：" :required="true"  v-if="showStockQuantity&&!justShow&&!goodsData.isExternalUrl">
             <el-input-number :disabled="specificationsItem.stockQuantity?true:false" :class="$style['number-input','number-input-price']" controls-position="right" v-model="goodsOtherInfoDTO.stockQuantity" :min="0"  data-vv-as="库存" name="name"  v-validate="'required'"></el-input-number>
         </pt-form-list-item>
         <!-- </template> -->
    </table>
    <pt-sub-title title="支付形式"></pt-sub-title>
    <table>
      <pt-form-list-item  width="5em" :required="true" class="pt-form-list-item-tr" label="支付形式："   @widthItem="widthItem"  :widthMax="width_max">
        <wt-checkbox :class="$style['payment-checkbox']" :checkList="paymentModesOptions" v-model="goodsData.paymentModes" v-validate="'required'" data-vv-as="支付形式" name="name"></wt-checkbox>
         <div :class="$style['goods-table-div']" class="page-background" v-if="isShow_DEPOSIT_AND_BALANCE">
        <table :class="$style['specification-table']">
          <template v-if="isSpecificationsItems">
          <th>
            <td></td>
            <td>价格</td>
            <td>订金</td>
            <td>尾款</td>
          </th>
          <tr v-for="(item,index) in specificationsItems" :key="index">
            <td>{{item.name}}</td>
            <td>{{item.show_price_payment}}</td>
            <td><wt-input @change="depositShowPriceInput(item)" v-model="item.deposit_show" data-vv-as="订金" name="name"
            :class="$style['specifications-tr-input']" v-validate="'required'"></wt-input></td>
            <td>{{item.balance_show}}</td>
          </tr>
          </template>
          <template v-else>
            <th>
            <td>价格</td>
            <td>订金</td>
            <td>尾款</td>
          </th>
          <tr>
            <td>{{goods_price_show}}</td>
            <td>
              <wt-input @change="depositShowNospePriceInput" v-model="goodsData.noSpecificationsDeposit_show" data-vv-as="订金" name="name"
            :class="$style['specifications-tr-input']" v-validate="'required|decimal:2|min_value:0|is_not:0'"></wt-input>
            </td>
            <td>{{goodsData.balance_show}}</td>
          </tr>
          </template>
        </table>
         </div>
      </pt-form-list-item>
    </table>
    <template  v-if="!justShow&&!goodsData.isExternalUrl">
    <pt-sub-title title="发货形式"></pt-sub-title>
    <table>
        <pt-form-list-item  width="5em" :required="true" class="pt-form-list-item-tr" label="发货形式："   @widthItem="widthItem"  :widthMax="width_max">
            <wt-radio v-model="goodsData.shippingMode" :radios="shippingModes" data-vv-as="发货方式"
            name="shippingModes"  v-validate="'required'"></wt-radio>
        </pt-form-list-item>
    </table>
     <pt-sub-title title="其他设置" ></pt-sub-title>
     <table :class="$style['message-table']" border="0" >
          <pt-form-list-item label="售后政策："    @widthItem="widthItem"  :widthMax="width_max">
              <wt-selector :options="afterSalesPolicieList" v-model="goodsData.afterSalesPolicyId" :props="policieProp"></wt-selector>
              <el-button style="margin-left:10px;" type="primary" @click="addAfterSalesPolicie">添加售后政策</el-button>
          </pt-form-list-item>
          <pt-form-list-item label="说明：" v-if="goodsData.afterSalesPolicy">
              <div :class="$style['privacy-policy-detail']" v-html="goodsData.afterSalesPolicy"></div>
              <!-- <wt-input  type="textarea" rows='4' :autosize="{ minRows: 5, maxRows:8}" class="afterSale-detail" v-model="goodsData.afterSalesPolicy"></wt-input> -->
          </pt-form-list-item>
            <pt-form-list-item label="运费规则："    @widthItem="widthItem"  :widthMax="width_max">
              <wt-selector :options="carriagePoliciesList" v-model="goodsData.carriagePolicyId" :props="policieProp"></wt-selector>
              <el-button style="margin-left:10px;" type="primary" @click="addCarriagePolicy">添加运费规则</el-button>
          </pt-form-list-item>
          <pt-form-list-item label="内容：" v-if="goodsData.carriagePolicy">
              <div :class="$style['afterSale-detail']">
                  {{goodsData.carriagePolicy}}
              </div>
              <!-- <wt-input  type="textarea" rows='4' :autosize="{ minRows: 5, maxRows:8}" class="afterSale-detail" v-model="goodsData.carriagePolicy"></wt-input> -->
          </pt-form-list-item>
          <pt-form-list-item label="隐私条款："    @widthItem="widthItem"  :widthMax="width_max">
              <wt-selector :options="privacyPolicyList" v-model="goodsData.privacyPolicyId" :props="policieProp"></wt-selector>
              <el-button style="margin-left:10px;" type="primary" @click="addPrivacyPolicy">添加隐私条款</el-button>
          </pt-form-list-item>
          <pt-form-list-item label="内容：" v-if="privacyPolicyDetail">
              <div :class="$style['privacy-policy-detail']" v-html="privacyPolicyDetail"></div>
          </pt-form-list-item>
     </table>
     </template>
     <template v-if="!goodsData.isExternalUrl">
        <pt-sub-title title="商品详情"></pt-sub-title>
        <wt-ueditor resource="goods" ref="ueditor"  v-model="goodsData.detail" :content="content" ></wt-ueditor>
        <!-- <wt-simditor-textarea :class="$style['goods-detail']" v-model="goodsData.detail" :content="content" :publicImageUrl="privateResourcesUrl" :fileUploadUrl="fileUploadUrlKey"
        :params="picture_params_sim"></wt-simditor-textarea> -->
    </template>
 </div>
</template>
<script>
import { logisticsMessage, goodsTags, cycleRadios, BelongLabels, shippingModes, collectionsLabel, provideInvoiceList,
  paymentModesOptions } from '../goods-options'
import formMixins from 'mixins/form'
import specificationTable from './specification-table'
import { cashCount, minValueMethod, maxValueMethod, isEmptyObject } from 'utils/formUtils'
import genePackageOfGoods from './gene-package-of-goods'
import taxProjectComp from './tax-project'
const Gene = 'GENE'// 基因枚举
export default {
  name: 'goods-form',

  mixins: [formMixins],
  props: {
    goodsForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    goodsGroup: {
      type: Array,
      default: function () {
        return []
      }
    },
    genePackage: {
      type: Array,
      default: function () {
        return []
      }
    },
    content: {
      type: String,
      default: ''
    },
    afterSalesPolicieList: {
      type: Array,
      default: function () {
        return []
      }
    },
    carriagePoliciesList: {
      type: Array,
      default: function () {
        return []
      }
    },
    id: {
      type: String,
      default: ''
    },
    vendorsOrganizations: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    goodsTypes: {
      type: Array,
      default: function () {
        return []
      }
    },
    goodsTypeLoading: {
      type: Boolean,
      default: false
    },
    afterSalesPolicy: {
      type: Object,
      default: function () {
        return {}
      }
    },
    carriagePolicy: {
      type: Object,
      default: function () {
        return {}
      }
    },
    privacyPolicyList: {
      type: Array,
      default: function () {
        return []
      }
    },
    privacyPolicy: {
      type: Object,
      default: function () {
        return {}
      }
    },
    taxProject: {
      type: [Object, String],
      default: function () {
        return {}
      }
    },
    companyList: {
      type: Array,
      default: function () {
        return []
      }
    },
    companyListWechat: {
      type: Array,
      default: function () {
        return []
      }
    },
    businessDepartments: {
      type: Array
    }
  },
  components: {
    specificationTable,
    genePackageOfGoods,
    taxProjectComp
  },
  computed: {
    specificationsItem () {
      return (this.specifications && this.specifications[0] && this.specifications[0].items && this.specifications[0].items[0]) || {}
    },
    justShow () {
      return this.goodsData.justShow
    },
    isThirdParty () {
      return this.goodsData.goodsBelong === 'THIRD_PARTY'
    },
    isGENE () {
      return this.goodsData.type === 'GENE'
    },
    // 是否需要套餐
    isShowPackage () {
      return this.isGENE && !this.justShow
    },
    // 是否显示税务项目
    isHasTax () {
      return !(this.justShow || this.goodsData.isExternalUrl) && (this.goodsData.goodsBelong !== 'THIRD_PARTY' || this.vendorInfo.paymentAccount !== 'THIRD_PARTY') && this.goodsData.provide_invoice !== 'false'
    },
    // 是否显示税务项目的表格
    isHasTaxTable () {
      return this.tax_project && !isEmptyObject(this.tax_project)
    },
    // 是否可选择供应商
    isSelectVendorsOrganizations () {
      return this.vendorInfo.paymentAccount === 'THIRD_PARTY' || this.vendorInfo.paymentAccount === 'MOLECULAR_COMPANY'
    },
    isSpecificationsItems () {
      return this.specifications && this.specifications.length && this.specifications[0] && this.specifications[0].items && this.specifications[0].items.length
    },
    // 是否显示规格的订金+尾款表格
    isShow_DEPOSIT_AND_BALANCE () {
      return this.goodsData.paymentModes &&
      this.goodsData.paymentModes.length && this.goodsData.paymentModes.indexOf('DEPOSIT_AND_BALANCE') > -1
    },
    // 供应商是否是分子公司
    isMolecularCompany () {
      return this.vendorInfo && this.vendorInfo.paymentAccount === 'MOLECULAR_COMPANY'
    },
    organizationOptions () {
      return this.vendorInfo.paymentAccount === 'MOLECULAR_COMPANY' ? this.companyListWechat : this.vendorsOrganizations
    },
    paymentLabel () {
      return this.vendorInfo.paymentAccount === 'MOLECULAR_COMPANY' ? '收款分子公司' : '收款供应商'
    },
    // 规格是否显示折后价
    isShowPromotionPrice () {
      let specifications = this.specifications && this.specifications[0] && this.specifications[0].items
      let hasPromotionPrice = false
      specifications.forEach(item => {
        if (item.promotionPrice) {
          hasPromotionPrice = true
        }
      })
      return hasPromotionPrice
    },
    // 根据表单判断支付对象表单作为必填项
    formIsRequired () {
      return this.vendorInfo.paymentAccount === 'COMPANY_ACCORDING_TO_FORM'
    }
  },
  data () {
    return {
      label_color: '#000',
      logisticsMessage: logisticsMessage,
      goodsTags: goodsTags,
      cycleRadios: cycleRadios,
      privateResourcesUrl: this.$publicResourcesUrl,
      fileUploadUrl: this.$uploadApi,
      fileUploadUrlKey: this.$uploadApiKey,
      uploadApi: this.$uploadApi,
      Gene: Gene,
      picture_params: {
        resourceName: 'goods',
        objectId: this.id || 0
      },
      picture_params_sim: {
        resourceName: 'goods',
        objectId: this.id || 0,
        key: 'file_path'
      },
      form: this.isEdit ? JSON.parse(JSON.stringify(this.goodsForm)) : { },
      goodsData: {
      },
      goodsOtherInfoDTO: {},
      groupProps: {
        label: 'name',
        value: 'id'
      },
      goodsTypeProps: {
        label: 'name',
        value: 'value'
      },
      goodsBelongLabels: BelongLabels,
      shippingModes: shippingModes,
      policieProp: {
        label: 'name',
        value: 'id'
      },
      vendorInfo: {},
      specifications: [],
      widthArr: [],
      collectionsLabel: collectionsLabel,
      showStockQuantity: false,
      privacyPolicyDetail: '',
      tax_project: this.taxProject,
      tax_requry: '',
      focusIndex: '',
      provideInvoiceList: provideInvoiceList,
      paymentModesOptions: paymentModesOptions,
      specificationsItems: null,
      goods_price_show: null,
      width_max: null, // 所有子模块的最大宽度
      formDisable: false
    }
  },
  watch: {
    selectLabels: {
      handler: function (val) {
        this.$set(this.goodsData, 'tags', val)
        this.goodsData.tags = val
      }
    },
    tax_project: {
      handler: function (val) {
        this.tax_requry = val && !isEmptyObject(val) ? 'has' : ''
      }
    },
    afterSalesPolicy: {
      handler: function (val) {
        this.$set(this.goodsData, 'afterSalesPolicyId', val.id)
        this.$set(this.goodsData, 'afterSalesPolicy', val.detail)
      },
      deep: true
    },
    carriagePolicy: {
      handler: function (val) {
        this.$set(this.goodsData, 'carriagePolicyId', val.id)
        this.$set(this.goodsData, 'carriagePolicy', val.content)
      },
      deep: true
    },
    privacyPolicy: {
      handler: function (val) {
        this.$set(this.goodsData, 'privacyPolicyId', val.id)
        // this.$set(this.goodsData, 'carriagePolicy', val.content)
        this.privacyPolicyDetail = val.content
      },
      deep: true
    },
    'goodsData.type' (val, old) {
      if (old) {
        this.cutBelongOrType()
      }
      if (val === 'GENE' && !this.justShow) {
        this.defaultSpecifications()
      }
      if (!this.isShowPackage && this.goodsData.genePackage && this.goodsData.genePackage.length > 0) {
        this.goodsData.genePackage = null
      }
    },
    'goodsData.justShow' (val) {
      // 如果商品是仅展示，删除默认规格
      if (val) {
        let specifications = this.specifications
        if (specifications) {
          specifications.forEach((item, index) => {
            if (item.name === 'default') {
              item.items = item.items.filter(etem => {
                if (etem.itemId === 'gene_unlock' || etem.itemId === 'gene_default') {
                  return false
                } else {
                  return true
                }
              })
              if (!item.items.length) {
                this.specifications.splice(0, this.specifications.length)
              }
              console.log('this.specifications', this.specifications)
            }
          })
        }
      }
    },
    goodsForm: {
      handler: function (val) {
        this.form = val
        this.goodsData = (val && val.goodsDTO && val.goodsDTO.goodsData) || { mallVisible: true, allowCustomerOrder: true, cycleType: 'NATURAL_DAY', provide_invoice: 'true' }
        this.specifications = this.goodsData.specifications || []
        this.goodsOtherInfoDTO = val.goodsOtherInfoDTO || {}
        this.vendorInfo = (val && val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData.vendorInfo) || {}
      }
    },
    goodsData: {
      handler: function (val) {
        this.form.goodsDTO = this.form.goodsDTO || {}
        this.form.goodsDTO.goodsData = val
        this.goods_price_show = val.final_price ? cashCount(cashCount(val.final_price), true, 2) : null
      },
      deep: true
    },
    vendorInfo: {
      handler: function (val) {
        this.form.goodsDTO.goodsData.vendorInfo = val
        let vendorInfo = this.form.goodsDTO.goodsData.vendorInfo
        this.vendorsOrganizations.forEach(item => {
          if (item.id === val.organizationId) {
            vendorInfo.organizationName = item.name
          }
        })
        vendorInfo = val
      },
      deep: true
    },
    'vendorInfo.paymentAccount' (val, old) {
      // if(val==='MOLECULAR_COMPANY'){
      // this.$emit('getCompany', val)
      // }
      this.$emit('getCompany', val)

      if (val === 'COMPANY_ACCORDING_TO_FORM') {
        this.goodsData.hasForm = true
        this.formDisable = true
      } else {
        this.goodsData.hasForm = false
        this.formDisable = false
      }
      if (old && old !== val) {
        this.$set(this.vendorInfo, 'organizationId', null)
      }
    },
    goodsOtherInfoDTO: {
      handler: function (val) {
        this.form.goodsOtherInfoDTO = val
      },
      deep: true
    },
    'goodsData.afterSalesPolicyId' (val) {
      this.afterSalesPolicieList.forEach(item => {
        if (val === item.id) {
          this.goodsData.afterSalesPolicy = item.detail
        }
      })
    },
    'goodsData.carriagePolicyId' (val) {
      this.carriagePoliciesList.forEach(item => {
        if (val === item.id) {
          this.goodsData.carriagePolicy = item.content
        }
      })
    },
    'goodsData.privacyPolicyId' (val) {
      this.privacyPolicyList.forEach(item => {
        if (val === item.id) {
          this.privacyPolicyDetail = item.content
        }
      })
    },
    'goodsData.goodsBelong': {
      handler: function (val, old) {
        if (old) {
          this.cutBelongOrType()
        }
        this.$emit('getGoodsTypeList', val)
        if (val === 'PLATFORM') {
          this.goodsData.isExternalUrl = false
        }
      }
    },
    specifications: {
      handler: function (val) {
        if (val && val[0] && val[0].items) {
          let items = val[0].items
          this.specificationsItems = items
          this.goodsOtherInfoDTO.stockQuantity = 0
          let isPrice = true
          if (items && items.length > 0) {
            items.forEach(item => {
              this.goodsOtherInfoDTO.stockQuantity = Number(this.goodsOtherInfoDTO.stockQuantity) + Number(item.stockQuantity)
              item.show_price_payment = (item.show_price && cashCount(cashCount(item.show_price), true, 2)) || null
              if (!item.show_price) {
                isPrice = false
              }
            })
          } else {
            isPrice = false
          }
          if (isPrice) {
            let price = (items[0] && items[0].show_price && minValueMethod(items, 'show_price')) || (minValueMethod(items, 'show_price') === 0 ? 0 : null)
            this.goodsData.final_price = price
          }
        }
        this.goodsData.specifications = val
      },
      deep: true
    },
    genePackage: {
      handler: function (val) {
        this.$set(this.goodsData, 'genePackage', val)
      },
      deep: true
    },
    taxProject: {
      handler: function (val) {
        this.tax_project = val
        this.$set(this.goodsData, 'taxProjectId', val.id)
      },
      deep: true
    }
  },
  methods: {
    hasFormChange (val) {
      console.log('this.formIsRequired', this.formIsRequired)
      if (this.formIsRequired && !val) {
        this.goodsData.hasForm = true
      }
    },
    justSalesmanChange (val) {
      val.inviterReward = val.inviterReward || {}
      val.inviterReward.justSalesman = val.justSalesman
    },
    // 价格验证方法
    auditValidate (val, type) {
      let inviterRewardMoney = val.inviterRewardMoney ? cashCount(val.inviterRewardMoney) : 0
      let salerRewardMoney = val.salerRewardMoney ? cashCount(val.salerRewardMoney) : 0
      let promotionPrice = val.promotionPrice ? cashCount(val.promotionPrice) : 0
      let price = val.price || (val.show_price && cashCount(val.show_price)) || 0
      if (promotionPrice) {
        if (salerRewardMoney > promotionPrice || inviterRewardMoney > promotionPrice || (salerRewardMoney + inviterRewardMoney > promotionPrice)) {
          this.$message.error('奖励总和不能大于折扣价')
          if (type === 'inviter') {
            val.inviterRewardMoney = null
          } else if (type === 'businesser') {
            val.salerRewardMoney = null
          }
        }
      } else {
        if (salerRewardMoney > price || inviterRewardMoney > price || (salerRewardMoney + inviterRewardMoney > price)) {
          this.$message.error('奖励总和不能大于商品价格')
          if (type === 'inviter') {
            val.inviterRewardMoney = null
          } else if (type === 'businesser') {
            val.salerRewardMoney = null
          }
        }
      }
    },
    inviterRewardMoneyInput (val) {
      if (val.inviterRewardMoney) {
        this.auditValidate(val, 'inviter')
      }
      val.inviterReward = val.inviterReward || {}
      val.inviterReward.money = cashCount(val.inviterRewardMoney)
    },
    salerRewardMoneyInput (val) {
      if (val.salerRewardMoney) {
        this.auditValidate(val, 'businesser')
        val.salesReward = val.salesReward || {}
        val.salesReward.money = cashCount(val.salerRewardMoney)
      }
    },
    rewardPointInput (val) {

    },
    depositShowNospePriceInput (val) {
      if (this.goods_price_show) {
        let deposit = val && cashCount(val)
        let price = this.goods_price_show && cashCount(this.goods_price_show)
        if (deposit > price) {
          this.$message.error('请输入小于/等于价格的订金')
          this.$set(this.goodsData, 'noSpecificationsDeposit_show', null)
        } else {
          let balance = (val && this.goods_price_show) ? (price - deposit) : null
          this.$set(this.goodsData, 'balance_show', cashCount(balance, true, 2))
        }
      } else {
        this.$message.error('请先输入商品价格')
        this.$set(this.goodsData, 'noSpecificationsDeposit_show', null)
      }
    },
    changeFinalPrice (val) {
      this.goods_price_show = val ? cashCount(cashCount(val), true, 2) : null
    },
    depositShowPriceInput (val) {
      if (val.show_price) {
        let deposit = val.show_price_payment && cashCount(val.deposit_show)
        let price = val.show_price && cashCount(val.show_price)
        if (deposit > price) {
          this.$message.error('请输入小于/等于价格的订金')
          this.$set(val, 'deposit_show', null)
        } else {
          let balance = (val.show_price && val.show_price_payment) ? (price - deposit) : null
          this.$set(val, 'balance_show', cashCount(balance, true, 2))
        }
      } else {
        this.$message.error('请先输入商品/规格价格')
        this.$set(val, 'deposit_show', null)
      }
    },
    showPriceFocus (index) {
      this.focusIndex = index
    },
    showPriceInput (val) {
      let items = this.specifications[0].items
      items.forEach((item, index) => {
        if (index === this.focusIndex) {
          this.$set(item, 'show_price', val)
        }
      })
      if (val) {
        let price = minValueMethod(items, 'show_price') || (minValueMethod(items, 'show_price') === 0 ? 0 : null)
        this.$set(this.goodsData, 'final_price', price)
      }
    },
    // 切换type和归属的时候，规格值清空
    cutBelongOrType () {
      let items = (this.specifications && this.specifications[0] && this.specifications[0].items) || []
      if (items.length > 0) {
        items.forEach(item => {
          this.$set(item, 'show_price', '')
        })
        this.specifications.sort()
      }
      this.specifications.splice(0, 1)
      this.goodsOtherInfoDTO.stockQuantity = null
      this.goodsData.final_price = null
    },
    selectTax () {
      this.$emit('selectTax')
    },
    weightChange (val) {
      let weight = val.weight
      if (weight < 1 || weight > 10) {
        this.$message.error('请输入大于1小于10的标签权重')
        this.$set(val, 'weight', 10)
      }
    },
    setGroup () {
      this.$router.push('/goods-group')
    },
    goodsBelongChange (val) {
    //   this.goodsData.type = ''
      this.$set(this.goodsData, 'type', null)
    },
    // 显示默认规格函数
    defaultSpecifications () {
      this.specifications = this.specifications || []
      this.specifications[0] = this.specifications[0] || {}
      let specifications = this.specifications[0]
      if (!specifications.name || !specifications.items) {
        specifications.name = specifications.name || 'default'
        specifications.items = specifications.items || []
        let arr = [{ itemId: 'gene_default', name: '购买完整检测（需采集样本）' }, { itemId: 'gene_unlock', name: '开启报告内容（无需采样）' }]
        arr.forEach(item => {
          specifications.items.push({
            ...item,
            stockQuantity: '',
            show_price: null,
            price: '' // 影响的价格
          })
        })
        this.specifications.sort()
      }
    },
    addAfterSalesPolicie () {
      this.$emit('addAfterSalesPolicie')
    },
    // 添加运费规则
    addCarriagePolicy () {
      this.$emit('addAfterSalesPolicie', 'carriagePolicy')
    },
    // 添加隐私条款
    addPrivacyPolicy () {
      this.$emit('addAfterSalesPolicie', 'privacyPolicy')
    },
    widthItem (val) {
      // 用于所有子模块的label对齐
      // 每个子模块中，随意挑选一个pt-form-list-item（因为同一个子模块，label的宽度是相等的）,使用此函数，获取此子模块中左边td即label部分的宽度，
      // 获取到所有子模块的宽度后，取出最大值，在每个子模块任意pt-form-list-item中传入最大宽度
      this.widthArr.push(val)
      this.width_max = maxValueMethod(this.widthArr)
    },
    expressCostChange (val) {
      this.form.goodsDTO.goodsData.expressCost = cashCount(val.extra_value)
    },
    // 添加规格
    addSpecifications () {
    //   let goodsData = this.form.goodsDTO.goodsData
      this.specifications = this.specifications || []
      this.specifications.push({
        name: 'default',
        items: [
          {
            name: '', // 明细项id
            stockQuantity: '',
            show_price: '',
            price: '' // 影响的价格
          }
        ]
      })
    },
    // 选择标签弹框
    selectLabs () {
      this.$emit('selectLabs')
    },
    selectMeal () {
      this.$emit('selectMeal')
    }
  },
  created () {
    this.showStockQuantity = this.$store.getters.showStockQuantity
    if (!this.isEdit) {
      this.form.goodsDTO = {}
      this.goodsData = (this.form && this.form.goodsDTO && this.form.goodsDTO.goodsData) || { mallVisible: true, allowCustomerOrder: true, cycleType: 'NATURAL_DAY', provide_invoice: 'true' }
      this.goodsOtherInfoDTO = this.form.goodsOtherInfoDTO || {}
    }
  }

}
</script>
<style module  lang="less">
@import "~less/var.less";
.product-code{
  width: 350px
}
.payment-checkbox{
  line-height: 40px
}
.goods-table-div{
    margin-top: 10px;
    padding: 10px 20px 30px;
}
.goods-form{
    :global
    .wt-selector{
        width: 350px
    }
    &>table{
        padding: 10px 20px;
        display: block;
        // max-width: 450PX;
        tr{
            max-width: 450PX;
        }
    }
    :global
.afterSale-detail{
    textarea{
        max-width: 100%;
        width: 100%
    }
}
}
.message-table{
    width: 100%;
    display: table!important;

    th,tr{
        display: table-row;
        width: 100%;
    }
     :global
    .wt-input{
        overflow: initial;
    }
    .el-input{
        width: auto!important
    }
    td{
        // padding-bottom: 10px;
        font-size: 14px;
        // color: @tipTextColor
    }
    textarea{
        max-width: 350px;
        font-family: "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", "Avenir", Helvetica, Arial!important
    }
}
.goods-form-tiptext{
    color: @tipTextColor;
    font-size: 14px;
    line-height: 40px;
    padding-left: 15Px
}
.specifications-tr-input{
    max-width: 120px;
    margin: 0 auto
}
.upload-file-text{
    // font-size: 15px;
}
.upload-tips-text{
    line-height: 40px;
    font-size: 14px;
}
.number-input{
    width: auto
}
.number-input-price{
    width: 200px
}
.goods-detail{
    // max-width: 900PX;
    max-height: 80vh;
    display: flex;
    position: relative;
    overflow-y: hidden;
    :global
    .simditor-textarea{
        display: flex;
        .simditor{
            display: flex;
            .simditor-wrapper{
                // display: flex;
                // flex-direction: column
                .simditor-body{
                    height:  calc(100% - 120px);
                    overflow-y: auto;
                    img{
                        max-width: 100%;
                    }
                }
            }
        }
    }
}
.goods-explain{
    padding:10px 15px;
    border-radius: 5px;
    :global
    p{
        color: #777;
        margin-block-start:5px;
        line-height: inherit;
        label{
            color: #636363;
            font-size: 16px;
            font-weight: 600
        }
        span{
            font-size: 16px;
        }
    }
}
.goods-name{
    max-width: 350px;
}
.specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
        padding: 10px;
    }
}
.specification-table-div{
     padding: 10px 20px 30px;
}
.goods-cycle{
    display: flex;
}
.cycle-radio{
    line-height: 40px;
    margin-left: 20px
}
.privacy-policy-detail{
    height: 200PX;
    overflow-y: auto;
    border-radius: 5px;
    border: 1px solid #e4e7ed;
    padding: 10px 15px
}
.afterSale-detail{
    min-height:80PX;
    overflow-y: auto;
    border-radius: 5px;
    border: 1px solid #e4e7ed;
    padding: 10px 15px
}

.reward-money-just-salesman{
  display: flex;
  :global
  .el-checkbox{
    line-height: 40px;
    margin-left: 10px
  }
}
</style>
<style lang="less">
.goods-banner-pictrue-upload{
 .el-upload--picture-card{
        width: 347px;
        height: 128px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    .el-upload-list__item{
        .el-upload--picture-card;
         box-sizing:inherit
    }
}
.goods-pictrue-upload{
    .el-upload--picture-card{
        width: 212px;
        height: 150px;
        display:inline-flex;
        align-items: center;
        justify-content: center;
    }
    .el-upload-list__item{
        .el-upload--picture-card;
        box-sizing:inherit
    }
}
.main-pictrue-upload{
    .el-upload--picture-card{
        width: 150px;
        height: 150px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    .el-upload-list__item{
        .el-upload--picture-card;
        box-sizing:inherit
    }
}
</style>
